import { render, staticRenderFns } from "./pdfTemplatesList.vue?vue&type=template&id=511a70b2&scoped=true&"
import script from "./pdfTemplatesList.vue?vue&type=script&lang=js&"
export * from "./pdfTemplatesList.vue?vue&type=script&lang=js&"
import style0 from "./pdfTemplatesList.vue?vue&type=style&index=0&id=511a70b2&lang=scss&scoped=true&"
import style1 from "./pdfTemplatesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511a70b2",
  null
  
)

export default component.exports